import service, { type HttpResponseSuccess } from '@/services/service';
import { StepsType } from '@/modules/sequencesRedesign/hooks/useSequences';

const apiClient = service(`${process.env.REACT_BACKEND_HOST}`);

export interface AiSequencePayload {
	targetAudience: string;
	offering: string;
	valueProposition: string;
	signature: string;
}

export interface AiSequenceResponse {
	name: string;
	description: string;
	isAiGenerated: boolean;
	steps: StepsType[];
}

export const AI_SEQUENCE_QUERY_KEY = ['onboardingAiSequence'];

export const generateAiSequence = (
	payload: AiSequencePayload
): Promise<HttpResponseSuccess<AiSequenceResponse>> =>
	apiClient.post('/api/campaigns/generateAiCampaign', payload);
